import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

export default function OfferOnly() {
  const navigate = useNavigate();

  const handleShare = () => {
    const shareUrl = window.location.origin;
    const shareText = 'Fiz o Teste dos 4 Elementos e o resultado foi revelador! Descubra qual elemento está bloqueado na sua vida:';
    if (navigator.share) {
      navigator.share({ title: 'Teste dos 4 Elementos', text: shareText, url: shareUrl }).catch(() => {});
    } else {
      window.open(`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`, '_blank');
    }
  };

  return (
    <>
      <Helmet>
        <title>Mapa de Cura dos 4 Elementos</title>
        <meta name="description" content="Descubra os bloqueios dos seus 4 elementos e receba seu mapa de cura personalizado." />
        {/* Favicon exclusivo da página do Mapa */}
        <link rel="icon" type="image/svg+xml" href="https://static.lumi.new/83/83e3e2db4feed9e773266a9568372f22.svg" />
        <link rel="shortcut icon" href="https://static.lumi.new/83/83e3e2db4feed9e773266a9568372f22.svg" />
        <link rel="apple-touch-icon" sizes="180x180" href="https://static.lumi.new/83/83e3e2db4feed9e773266a9568372f22.svg" />
        {/* OG exclusivo do Mapa de Cura dos 4 Elementos */}
        <meta property="og:title" content="Mapa de Cura dos 4 Elementos" />
        <meta property="og:description" content="Descubra os bloqueios dos seus 4 elementos e receba seu mapa de cura personalizado." />
        <meta property="og:image" content="https://static.lumi.new/4d/4d9eb47608d576453be16f9f0d1e6c10.svg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content="https://elementos.reacendaluz.com.br/mapa" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mapa de Cura dos 4 Elementos" />
        <meta name="twitter:description" content="Descubra os bloqueios dos seus 4 elementos e receba seu mapa de cura personalizado." />
        <meta name="twitter:image" content="https://static.lumi.new/4d/4d9eb47608d576453be16f9f0d1e6c10.svg" />
      </Helmet>

      <div className="reative-page mapa-page min-h-screen py-8 md:py-12 px-4" style={{ backgroundColor: '#0d0d0f' }}>
        <div className="text-center mb-8"></div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto">

          {/* Bloco 1 - Headline */}
          <div className="text-center px-4 py-12 md:py-20 mb-6 md:mb-10">
            <div className="flex items-center justify-center gap-3 mb-6 md:mb-8" aria-hidden="true">
              <span className="h-px w-12 md:w-24" style={{ backgroundColor: '#C9A96E' }} />
              <span className="w-2.5 h-2.5 rotate-45" style={{ backgroundColor: '#C9A96E' }} />
              <span className="h-px w-12 md:w-24" style={{ backgroundColor: '#C9A96E' }} />
            </div>
            <h2 className="mapa-hero-title font-bold mb-5 md:mb-6" style={{ fontFamily: 'Georgia, serif' }}>
              Mapa de Cura dos <span className="numerals">4</span> Elementos
            </h2>
            <p className="mapa-hero-subtitle mb-2 max-w-2xl mx-auto">
              Você tem dores que nunca conseguiu nomear. E são exatamente essas que estão prendendo a sua vida.
            </p>
          </div>

          {/* Bloco de Dor */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <div className="space-y-4 text-gray-300 leading-relaxed px-4 text-left md:text-center max-w-2xl mx-auto">
              <p>
                Você sente que algo está errado. Que por mais que tente, os mesmos ciclos se repetem. Que você avança um pouco e volta.
              </p>
              <p>
                Não é falta de fé. Não é falta de esforço. São dores que ficaram guardadas dentro de você. Dores que nunca foram vistas, nomeadas e liberadas.
              </p>
              <p>
                E enquanto essas dores não forem reveladas, elas continuam operando em silêncio, criando escassez, bloqueando relacionamentos, travando o propósito e impedindo que você viva a vida que veio viver.
              </p>
            </div>
          </div>

          {/* Bloco 2 - Apresentação de Mônica Maria */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8 text-center" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <div className="flex justify-center mb-6">
              <div
                className="w-40 h-40 md:w-52 md:h-52 rounded-full border-4 border-amber-500 shadow-2xl overflow-hidden flex items-center justify-center"
                style={{ backgroundColor: '#16161a' }}
              >
                <img
                  src="https://static.lumi.new/66/66a59164029fe3389411bfef927c8644.webp"
                  alt="Mônica Maria"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <div className="space-y-4 text-gray-300 leading-relaxed px-4 text-left md:text-center max-w-2xl mx-auto">
              <p>
                Sou Mônica Maria, Terapeuta Vibracional, criadora da Metodologia Trindade de Cura e do Método Reacenda sua Coroa. Mais de <span className="numerals">15</span> cursos lançados e milhares de pessoas transformadas. Todo o meu trabalho é revelar com profundidade o que ainda te prende e te mostrar quem você realmente é.
              </p>
              <p>
                O Mapa de Cura dos <span className="numerals">4</span> Elementos se torna um espelho do seu estado interior e te ensina uma prática poderosa para cocriar e viver a vida que você merece. Um mapa emocionante que ao ler toca profundamente, gerando transformação imediata da sua vibração, consciência e ser.
              </p>
            </div>
          </div>

          {/* Bloco 3 - Depoimentos */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <h2 className="font-bold text-white mb-3 text-center" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(24px, 6vw, 36px)' }}>
              O que estão dizendo sobre o Mapa de Cura dos <span className="numerals">4</span> Elementos
            </h2>
            <p className="text-gray-400 italic text-center mb-8">
              Depoimentos reais de mulheres que receberam o mapa.
            </p>
            <div className="testimonial-stack flex flex-col gap-3">
              <div className="testimonial-card rounded-2xl p-2 md:p-5 shadow-md" style={{ backgroundColor: '#1f1f24', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
                <div className="testimonial-media rounded-xl mb-2 overflow-hidden p-1 md:p-3" style={{ backgroundColor: '#1a1a1a' }}>
                  <img src="https://static.lumi.new/f3/f3618701217d5bbc4783b448a2172a65.webp" alt="Depoimento de Vitória" className="w-full rounded-lg" />
                </div>
                <p className="reative-testimonial font-bold text-center" style={{ color: '#C9A96E' }}>Vitória</p>
              </div>
              <div className="testimonial-card rounded-2xl p-2 md:p-5 shadow-md" style={{ backgroundColor: '#1f1f24', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
                <div className="testimonial-media testimonial-fatima rounded-xl mb-2 overflow-hidden p-1 md:p-3" style={{ backgroundColor: '#1a1a1a' }}>
                  <img src="https://static.lumi.new/c4/c4191e854efdbe14dbd34b3ec57cd45f.webp" alt="Depoimento de Fátima Verona" className="w-full rounded-lg" />
                </div>
                <p className="reative-testimonial font-bold text-center" style={{ color: '#C9A96E' }}>Fátima Verona</p>
              </div>
            </div>
          </div>

          {/* Bloco 4 - O que é o Mapa */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <div className="space-y-4 text-gray-300 leading-relaxed px-4">
              <p>
                Você acredita que tudo é energia. Que o que vibra dentro de você cria o que aparece na sua vida. Que existe algo mais profundo por trás dos ciclos que se repetem e você está no caminho certo.
              </p>
              <p>
                Existe uma raiz que ainda não foi revelada: um padrão bloqueado que opera de forma invisível, através de crenças antigas, memórias herdadas e dores não resolvidas, criando os mesmos ciclos na prosperidade, nos relacionamentos, nas emoções e no propósito.
              </p>
              <p>
                Enquanto essa raiz não for revelada e trabalhada, os ciclos continuam. O elemento se reequilibra por um tempo e volta a bloquear. Revelar essa raiz com clareza é o primeiro passo real para mudar de verdade.
              </p>
              <p className="font-bold text-center italic" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 5vw, 24px)', color: '#C9A96E' }}>
                É exatamente isso que o Mapa de Cura dos <span className="numerals">4</span> Elementos faz por você.
              </p>
            </div>
          </div>

          {/* Apresentação do Produto */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <div className="text-center mb-6 md:mb-8 px-4">
              <h2 className="font-bold mb-3" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(28px, 7vw, 48px)', color: '#C9A96E' }}>
                Mapa de Cura dos <span className="numerals">4</span> Elementos
              </h2>
              <p className="text-gray-400 italic font-semibold" style={{ fontSize: 'clamp(18px, 5vw, 24px)' }}>
                Individual e Personalizado
              </p>
            </div>
            <p className="text-gray-300 leading-relaxed mb-4 px-4">
              Para ter acesso ao seu mapa você vai responder um questionário com toda a sua honestidade, detalhando tudo aquilo que está incomodando a sua vida. E vai receber um documento escrito exatamente para você, nomeando as dores, crenças limitantes e padrões que estão bloqueando a sua vida.
            </p>
            <p className="text-white leading-relaxed font-semibold text-center px-4">
              Não é genérico. Não é igual para todo mundo. É sobre você, para você e com você.
            </p>
          </div>

          {/* O que você recebe */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <h2 className="font-bold text-white mb-8 md:mb-10 text-center" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(24px, 6vw, 36px)' }}>
              O que você recebe:
            </h2>
            <div className="space-y-4 md:space-y-6">
              {[
                { icon: '📋', title: 'Suas dores reveladas com uma clareza que você nunca teve', desc: 'Pela primeira vez você vai ver com clareza as dores guardadas dentro de você, as crenças limitantes e os padrões que se repetem, impedindo sua prosperidade, seus relacionamentos e sua evolução.' },
                { icon: '✨', title: 'O passo a passo para sentir de verdade cada dor, liberar e elevar seu estado interior', desc: 'Para cada dor que você revelar ao preencher o questionário, você recebe uma sequência personalizada de como sentir de verdade essa dor, como liberá-la da forma correta e como elevar sua vibração para criar a vida que você merece.' },
                { icon: '🪷', title: 'Uma prática simples e diária de 5 minutos para mudar tudo', desc: 'Um protocolo de poucos minutos para realizar ao acordar e antes de dormir, criado a partir do que você quer conquistar. Simples, fácil de fazer todos os dias e poderoso o suficiente para transformar tudo.' },
                { icon: '💫', title: 'Seu roteiro de elevação diária', desc: 'Passo a passo das declarações que vão te ajudar a sair dos pensamentos negativos e criar uma vida diferente, mesmo que hoje você ainda não acredite que isso seja possível.' }
              ].map((item, idx) => (
                <div key={idx} className="rounded-2xl p-5 md:p-6 shadow-md" style={{ backgroundColor: '#1f1f24', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
                  <div className="flex items-start gap-3 md:gap-4">
                    <span className="text-3xl md:text-4xl flex-shrink-0">{item.icon}</span>
                    <div>
                      <h3 className="reative-bonus-title font-bold text-white mb-3">
                        {item.title}
                      </h3>
                      <p className="reative-bonus-text text-gray-300 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Programa Eleve e Prospere */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-10 mb-6 md:mb-8 text-left" style={{ backgroundColor: '#241a05', border: '1px solid rgba(201, 169, 110, 0.45)' }}>
            <p className="font-bold leading-relaxed mb-3" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 5vw, 26px)', color: '#C9A96E' }}>
              🎁 Bônus especial: Programa Eleve e Prospere, <span className="numerals" style={{ color: '#9ca3af', textDecoration: 'line-through' }}>R$297</span>.
            </p>
            <p className="text-gray-200 leading-relaxed">
              <span className="numerals">14</span> aulas completas para desbloquear os <span className="numerals">4</span> elementos no seu dia a dia e práticas poderosas para elevar sua vibração. Você recebe acesso completo, sem custo adicional.
            </p>
          </div>

          {/* Bloco de Profundidade */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <div className="space-y-4 text-gray-300 leading-relaxed px-4 text-left md:text-center max-w-2xl mx-auto">
              <p>
                Este não é um diagnóstico genérico. É um espelho do que está vivo dentro de você, escrito com presença, cuidado e profundidade, para que pela primeira vez você veja com clareza o que está prendendo sua vida e como liberar.
              </p>
              <p>
                Este é um processo individual e de alta profundidade. Cada mapa é preparado com minha presença e dedicação totais, lendo cada resposta com atenção e cuidado, para que o que chegar até você seja preciso, poderoso e transformador.
              </p>
            </div>
          </div>

          {/* Preço e Botão */}
          <div className="rounded-3xl shadow-2xl p-6 md:p-12 mb-6 md:mb-8" style={{ backgroundColor: '#1a1200', border: '1px solid rgba(201, 169, 110, 0.45)' }}>
            <div className="text-center mb-6 md:mb-8 px-4">
              <div className="rounded-2xl p-5 md:p-7 mb-6 md:mb-8 text-left" style={{ backgroundColor: '#241a05', border: '1px solid rgba(201, 169, 110, 0.45)' }}>
                <p className="font-bold leading-relaxed" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 5vw, 26px)', color: '#C9A96E' }}>
                  🎯 Bônus por tempo limitado. Ao adquirir o Mapa de Cura dos <span className="numerals">4</span> Elementos hoje, você ganha <span className="numerals">1</span> atendimento individual de <span className="numerals">30</span> minutos comigo para liberar ao vivo o seu maior bloqueio.
                </p>
              </div>
              <div className="mb-6 md:mb-8">
                <p className="font-bold mb-2 numerals reative-price" style={{ fontFamily: 'Georgia, serif', color: '#C9A96E' }}>R$97</p>
                <p className="font-semibold mb-4 numerals reative-price-parcel" style={{ color: '#E0C992' }}>
                  ou 6x de R$18,20 no cartão
                </p>
                <p className="text-gray-400 italic">
                  Acesso imediato após a compra.
                </p>
              </div>
              <p className="font-bold text-white italic mb-6 md:mb-8" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(18px, 4.5vw, 22px)' }}>
                Este mapa será criado especificamente para você. Para cada dor que você revelar, você recebe o caminho de como senti-la de verdade, como liberá-la da forma correta e como elevar sua vibração para criar a vida que você merece.
              </p>
            </div>
            <motion.a
              href="https://pay.hotmart.com/V105026857E?checkoutMode=10"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="reative-cta block w-full font-bold rounded-2xl shadow-2xl transition-all duration-300 text-center"
              style={{ minHeight: '56px', lineHeight: '1.2', backgroundColor: '#C9A96E', color: '#0d0d0f' }}>
              Quero meu Mapa de Cura dos <span className="numerals">4</span> Elementos
            </motion.a>
          </div>

          {/* Como Funciona Após a Compra */}
          <div className="rounded-3xl shadow-xl p-6 md:p-10 mb-6 md:mb-8" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <h3 className="font-bold text-white mb-4 text-center" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 5vw, 28px)' }}>
              Como Funciona Após a Compra
            </h3>
            <div className="space-y-4 text-gray-300 leading-relaxed px-4">
              <p>
                Assim que você confirmar seu pedido, receberá no WhatsApp o link do formulário para preencher com suas respostas. O formulário é a base de tudo. É a partir do que você compartilhar que o seu Mapa será criado.
              </p>
              <p>
                Após o preenchimento, seu Mapa de Cura dos <span className="numerals">4</span> Elementos personalizado será entregue em até <span className="numerals">72</span> horas no seu e-mail.
              </p>
              <p className="font-semibold text-white text-center italic">
                Não é genérico. Não é automático. É criado especificamente para o que você revelou.
              </p>
            </div>
          </div>

          {/* Garantia */}
          <div className="rounded-3xl shadow-xl p-6 md:p-10 mb-6 md:mb-8 border border-green-700/50 text-center" style={{ backgroundColor: '#0a1a0e' }}>
            <div className="text-4xl md:text-5xl mb-4">🛡️</div>
            <h3 className="font-bold text-white mb-4" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 5.5vw, 28px)' }}>
              Garantia Incondicional de <span className="numerals">7</span> Dias
            </h3>
            <p className="reative-warranty text-gray-300 leading-relaxed mb-3 px-4">
              Se você receber o seu mapa e sentir que não foi o que esperava, basta me enviar uma mensagem e devolvo <span className="numerals">100%</span> do seu investimento.
            </p>
            <p className="reative-warranty text-gray-300 leading-relaxed px-4">
              Sem perguntas. Sem burocracia.
            </p>
          </div>

          {/* Fechamento */}
          <div className="rounded-3xl shadow-xl p-6 md:p-10 mb-6 md:mb-8 text-center" style={{ backgroundColor: '#16161a', border: '1px solid rgba(201, 169, 110, 0.28)' }}>
            <p className="text-gray-300 leading-relaxed italic mb-6 px-4" style={{ fontSize: 'clamp(18px, 4.5vw, 20px)', color: '#E0C992' }}>
              Você já sentiu que algo precisa mudar. O Mapa é o primeiro passo real para liberar o que está bloqueando a sua vida.
            </p>
            <div className="pt-6 mt-6 px-4" style={{ borderTop: '1px solid rgba(201, 169, 110, 0.28)' }}>
              <p className="font-bold text-white mb-2" style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(20px, 5.5vw, 28px)' }}>
                Mônica Maria
              </p>
              <p style={{ fontSize: 'clamp(18px, 4.5vw, 20px)', color: '#C9A96E' }}>
                Reacenda Luz
              </p>
            </div>
          </div>

          {/* Rodapé Final */}
          <div className="reative-footer text-center text-gray-600 border-t border-gray-800 pt-6 px-4">
            <p className="mb-2">Material exclusivo e protegido.</p>
            <p className="font-bold mb-2">Mônica Maria, Reacenda Luz.</p>
            <p>Proibida a reprodução sem autorização.</p>
          </div>
        </motion.div>
      </div>
    </>
  );
}
